import { render, staticRenderFns } from "./TaskCom.vue?vue&type=template&id=5b378f00&"
import script from "./TaskCom.vue?vue&type=script&lang=ts&"
export * from "./TaskCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports